<template>
  <div id="wrap">
    <left-side></left-side>
    <mobile-header/>
    <div id="content" ref="content">
      <!--<loading/>-->
      <div class="contentBox" v-if="id === 'sunnyfactory'" is="sunnyfactory">
      </div>
      <div class="contentBox" v-else-if="id === 'portfolio'" is="portfolio">
      </div>
      <div class="contentBox" v-else-if="id === 'contactus'" is="contact-us">
      </div>
      <div class="contentBox" v-else>
      </div>
    </div>
  </div>
</template>

<script>
    import LeftSide from  '@/components/menu/layouts/LeftSide'
    import ContactUs from  '@/components/menu/ContactUs'
    import Portfolio from  '@/components/menu/Portfolio'
    import Sunnyfactory from  '@/components/menu/Sunnyfactory'
    import NotFound from '@/components/NotFound'
    import RingLoader from "vue-spinner/src/RingLoader";
    import Loading from "./Loading";
    import MobileHeader from "./MobileHeader";


    export default {
        name: "layout" ,
        props : ['id'],
        components: {
          MobileHeader,
          Loading,
          'left-side' : LeftSide,
          'portfolio' : Portfolio,
          'sunnyfactory' : Sunnyfactory,
          'contact-us' : ContactUs,
          'not-found' : NotFound,
          RingLoader,
        },
        data () {
          return {
            permitUrl : [
              'sunnyfactory' ,
              'portfolio' ,
              'contactus'
              ],
            loading : false,
          }
        },
        /*beforeRouteEnter (to , from , next) {
          console.log(to);
        },*/
        created() {
          //console.log(this.permitUrl.indexOf(this.id));
          if (this.id === null || this.permitUrl.indexOf(this.id) === -1) {
            this.$router.push('/404');
          }

          //this.$router.resolve(location , current , appen)
        },
        updated() {
          if (this.id === null || this.permitUrl.indexOf(this.id) === -1) {
            this.$router.push('/404');
          }else{
            this.$refs.content.scrollTop = 0;
            if(this.$store.state['mobileNavStore'].active){
              this.$store.commit('mobileNavStore/SET__ACTIVE' , false);
            }

          }
        },
    }
</script>

<style scoped lang="scss">
  @import '@/styles/Global.scss';
  #wrap {
    width:100%;
    height:100%;
    display:flex;
    flex-direction: row;
    position: relative;
    @include respond-to('medium') {
      flex-direction: column;
    }
    #mobileHeaderSpace {
      width: 100%;
      height: 100px;
      display: none;
      @include respond-to('medium') {
        display: block;
      }
    }
    #content {
      flex:1;
      @include respond-to('medium') {
        flex:initial;
        width:100%;
      }
      overflow-y:scroll;
      -webkit-overflow-scrolling:touch;
      background-color:#f4f4f4;
      .contentBox{
        width:100%;
        flex:1;
        @include respond-to('medium') {
          //display: block;
          margin-top:100px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/menu/layouts/Sf.vue